import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ApiloaderService } from 'src/app/shared/loaders/apiloader/apiloader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private requests: HttpRequest<any>[] = [];

  constructor(private apiLoaderService: ApiloaderService) {}

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   if (!this.strategy.isCacheable(req)) {
  //     return next.handle(req);
  //   }

  //   // Notify the ApiloaderService of the new request
  //   this.apiLoaderService.setRequest(req);

  //   return next.handle(req).pipe(
  //     finalize(() => {
  //       // Notify the ApiloaderService when the request is complete
  //       this.apiLoaderService.removeRequest(req);
  //     })
  //   );
  // }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoader = req.headers.get('X-Skip-Loader') === 'true';
    //this.totalRequests++;
    if (!skipLoader) {
      this.requests.push(req);
      this.apiLoaderService.show();
    }

    return next.handle(req).pipe(
      finalize(() => {
        //this.totalRequests--;
        this.requests = this.requests.filter(r => r !== req);
        if (this.requests.length === 0) {
          this.apiLoaderService.hide();
        }
      })
    );
  }

}
